import { PageTitles } from '@revelio/core';
import { Link, Text } from '@revelio/ui';

import DashboardPage from '../../DashboardPage';
import { TrailPageConent } from '../../deliverables/trial-pages/components/trial-page-content';
import styles from './data-builder-trial-page.module.css';

const SAMPLE_FILES = [
  {
    label: 'Workforce Dynamics (.csv)',
    href: '/assets/csv/revelio_wf_dynam_geo_breakdown_sample.csv',
  },
  {
    label: 'Transitions (.csv)',
    href: '/assets/csv/revelio_transition_inflow_sample.csv',
  },
  {
    label: 'Job Postings (.csv)',
    href: '/assets/csv/revelio_postings_dynamics_sample.csv',
  },
  {
    label: 'Sentiment Data (.csv)',
    href: '/assets/csv/revelio_sentiment_individual_reviews_sample.csv',
  },
  {
    label: 'Layoff Notices (.csv)',
    href: '/assets/csv/revelio_layoffs_sample.csv',
  },
];

export const DataBuilderTrialPage = () => {
  return (
    <DashboardPage
      title={[PageTitles.DELIVERABLES, PageTitles.DATA_BUILDER]}
      loading={false}
      scrollY={true}
    >
      <TrailPageConent>
        <div className={styles.content}>
          <Text
            as="h1"
            className={styles.pageTitle}
            fontSize="lg"
            weight="semibold"
          >
            Data Builder
          </Text>
          <Text>
            Customize your own workforce dataset, no coding or technical skills
            required. Define the desired levels of aggregation, variables, and
            filters for any of our datasets (Workforce Dynamics, Transitions,
            Job Postings, Sentiment Data, Layoff Notices, Individual Level Data)
            to generate the insights most meaningful to your business.
          </Text>
          <Text
            as="h2"
            className={styles.sectionTitle}
            fontSize="x-bg"
            weight="semibold"
          >
            Sample Files
          </Text>
          <ul className={styles.sampleList}>
            {SAMPLE_FILES.map(({ label, href }) => (
              <li key={href}>
                <Link
                  href={href}
                  underline="always"
                  className={styles.sampleLink}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </TrailPageConent>
    </DashboardPage>
  );
};
